import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { toast } from "@/components/kit";
import { ProductFormPageHeader } from "@/modules/products/presentation/ui/ProductFormPageHeader";
import { useCreateExpense } from "../api/queries";
import { ExpenseForm } from "../ui/ExpenseForm";

export function ExpenseCreatePage() {
  const nav = useNavigate({ from: "/app/expenses/new" });
  const create = useCreateExpense();

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title="ເພີ່ມລາຍຈ່າຍ"
          subtitle="ບັນທຶກຄ່າແອດ Facebook ຫຼື ລາຍຈ່າຍຮ້ານເພື່ອຄຳນວນກຳໄລສຸດທິ"
          onBack={() => nav({ to: "/app/expenses" })}
        />

        <ExpenseForm
          submitting={create.isPending}
          onSubmit={async (values) => {
            try {
              await create.mutateAsync(values);
              toast.success("ເພີ່ມລາຍຈ່າຍແລ້ວ");
              nav({ to: "/app/expenses" });
            } catch (e) {
              toast.error("ບັນທຶກລົ້ມເຫຼວ", {
                description: e instanceof Error ? e.message : undefined,
              });
            }
          }}
        />
      </Main>
    </>
  );
}
